import { loadableWithRetry } from '../../common/utils/lazyLoad'

const routes = [
  {
    path: '/',
    exact: true,
    name: 'needsAction',
    component: loadableWithRetry(() => import('./NeedsAction')),
    publicRoute: true,
  },
]

export default routes
